import React from "react";
import { CustomLoading } from "components/CustomLoading";
import "bootstrap/dist/css/bootstrap.min.css";
import { KTMScreen} from "ktm-ui";
import AdvisorsReport from "./AdvisorsReport";
import DistroAccountsReport from "./DistroAccountsReport";
import JgIncomingDrawer from "./JgIncomingDrawer";
import JgDirectorsReport from "./JgDirectorsReport";
import { Building2, Users, MapPin } from 'lucide-react';

const navItems = [
  { label: "Distro Accounts", icon: Building2 },
  { label: "Advisors", icon: Users },
  { label: "RMD/BDD Management", icon: MapPin },
];

export default KTMScreen(
  { name: "advisors" },
  class extends React.Component<any, any> {
    state = {
      loading: true,
      currentListItem: "Distro Accounts",
    };

    componentDidMount() {
      this.setState({ loading: false });
    }

    setCurrentItem = (item) => {
      this.setState({ currentListItem: item });
    };

    render() {
      let container = null;
      let contents = null;
      if (this.state.loading) {
        contents = <CustomLoading />;
      } else {
        if (this.state.currentListItem == "Distro Accounts") {
          contents = <DistroAccountsReport/>;
        } else if (this.state.currentListItem == "Advisors") {
          contents = <AdvisorsReport/>;
        } else if (this.state.currentListItem == "RMD/BDD Management") {
          contents = <JgDirectorsReport/>;
        }

        container = (
          <div className="ktm-reports">
            <div className="advisor-nav">
              {navItems.map((item, index) => (
                <button
                  key={index}
                  className={`advisor-nav-item${this.state.currentListItem === item.label ? ' active' : ''}`}
                  onClick={() => this.setCurrentItem(item.label)}
                >
                  <item.icon size={18} />
                  {item.label}
                </button>
              ))}
            </div>
            <div className="advisor-content-card">
              {contents}
            </div>
          </div>
        );
      }
      return (
        <div className="advisor-page-container">
          {container}
          <JgIncomingDrawer />
        </div>
      );
    }
  }
);
